import { ChargerProducts } from '../common/enums/Products'
import { ChargePointImport } from '../common/redux/api/web-api'

const isHalo = (entity: { productId?: number } | number): boolean => {
    const productId = typeof entity === 'number' ? entity : entity?.productId

    if (!productId) return false

    return productId === ChargerProducts.Halo1 || productId === ChargerProducts.Halo2
}

export const isHaloImport = (chargePoint: ChargePointImport | undefined) =>
    chargePoint?.productType === 'Halo1' || chargePoint?.productType === 'Halo2'

export default isHalo
